import e, { OPTIONS as L } from "../managers/braze-instance.js";
import V from "../util/browser-detector.js";
import nr from "./l10n-manager.js";
const Ce = {
  t: !1,
  i: null,
  m: () => {
    if ((Ce.o(), !Ce.i)) {
      let r = V.language,
        t = !1;
      e.nn(L.Ba) && ((r = e.nn(L.Ba)), (t = !0)), (Ce.i = new nr(r, t));
    }
    return Ce.i;
  },
  o: () => {
    Ce.t || (e.g(Ce), (Ce.t = !0));
  },
  destroy: () => {
    (Ce.i = null), (Ce.t = !1);
  },
};
export default Ce;
